module.exports = __webpack_public_path__ + "static/sec5-leaves-ce4eb4b81e5ad9d07f6c515a0f608758.png";